import React, { useContext, useEffect, useState } from 'react'
import { apiGet } from '../../utils/apiFetch'
import Pagination from '../Pagination'
import AuthContext from 'context/AuthContext'
import { useNavigate, useLocation } from 'react-router-dom'
import AddressTable from './AddressTable'
import AddEditModal from './AddEditModal'
import { isEmpty, startCase } from 'lodash'
import { BiArrowBack } from 'react-icons/bi'

function City () {
  const location = useLocation()
  const navigate = useNavigate()
  const { user, updatePageName } = useContext(AuthContext)
  const manager =
    user?.permission?.find(e => e.manager === 'location_manager') ?? {}
  const [address, setAddress] = useState([])
  const [page, setPage] = useState(1)
  const [item, setItem] = useState()
  const [search, setSearch] = useState()
  const [pageSize] = useState(10)
  const [addEditModal, setAddEditModal] = useState(false)
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })
  const [sort, setSort] = useState({
    sortKey: 'createdAt',
    sortType: 'desc'
  })
  const allAddress = async data => {
    try {
      const payload = {
        page: !isEmpty(search) ? 1 : page,
        pageSize,
        keyword: search?.trim(),
        sortKey: sort.sortKey,
        sortType: sort.sortType
      }
      let path
      if (location.pathname === '/city') {
        path = '/v1/admin/cities'
        updatePageName('Cities')
      } else if (location.pathname === '/city/community') {
        updatePageName('Communities')
        path = '/v1/admin/communities?cityId=' + location.state?.id
      } else if (location.pathname === '/city/subCommunity') {
        updatePageName('Sub Communities')
        path = '/v1/admin/sub-communities?communityId=' + location.state?.id
      }
      const result = await apiGet(path, payload)
      const response = result?.data?.results
      const resultStatus = result?.data?.success
      setAddress(response?.docs)
      setPaginationObj({
        ...paginationObj,
        page: resultStatus ? response.page : null,
        pageCount: resultStatus ? response.totalPages : null,
        perPageItem: resultStatus ? response?.docs.length : null,
        totalItems: resultStatus ? response.totalDocs : null
      })
    } catch (error) {
      console.error('error in get all users list==>>>>', error.message)
    }
  }
  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }
  const setShowModal = newItem => {
    setItem(newItem)
    setAddEditModal(true)
  }

  useEffect(() => {
    allAddress()
  }, [page, sort, location, search])

  return (
    <div>
      <div className='bg-white'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] '>
            <form className='border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3'>
              {location.pathname !== '/city' ? (
                <div
                  className='flex justify-start items-center cursor-pointer mr-2'
                  onClick={() => {
                    setPage(1)
                    setSearch('')
                    navigate(-1)
                  }}
                >
                  <BiArrowBack className='h-8 w-8 border text-white py-1 rounded-md bg-[#6236FF] cursor-pointer' />
                  <span className='mb-2 ml-2 pt-2'>Go Back</span>
                </div>
              ) : null}
              <div className='2xl:ml-auto xl:ml-0 lg:pt-0 pt-2'>
                <div className='flex justify-between'>
                  <div className='relative '>
                    <div className='absolute inset-y-0 right-0 flex items-center pl-3 mr-3 pointer-events-none'>
                      <svg
                        aria-hidden='true'
                        className='w-4 h-4 text-[#A5A5A5] dark:text-gray-40'
                        fill='none'
                        stroke='currentColor'
                        viewBox='0 0 24 24'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        {!setSearch && (
                          <path
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            strokeWidth='2'
                            d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'
                          />
                        )}
                      </svg>
                    </div>
                    <input
                      type='search'
                      id='default-search'
                      title=''
                      className='block w-full p-2 outline-none text-sm text-gray-900 2xl:min-w-[300px] xl:min-w-[300px] rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                      placeholder={'Search by name, name (arabic)'}
                      value={search}
                      required
                      onChange={e => setSearch(e.target.value)}
                    />
                  </div>
                  {/* <button
                    type='button'
                    // onClick={handleReset}
                    className='bg-[#8FC150] text-sm px-8 ml-3 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] sm:w-auto w-1/2'
                  >
                    {t('O_RESET')}
                  </button> */}

                  {(manager?.add || user?.role === 'admin') && (
                    <button
                      title={`Add ${startCase(
                        location.pathname.replace('/', '')
                      )}`}
                      type='button'
                      className='bg-[#8FC150] text-sm px-8 ml-3 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] sm:w-auto w-1/2'
                      onClick={() => setShowModal(false)}
                    >
                      + Add {startCase(location.pathname.replace('/', ''))}
                    </button>
                  )}
                </div>
              </div>
            </form>
            <AddressTable
              address={address}
              allAddress={allAddress}
              page={page}
              setSort={setSort}
              sort={sort}
              manager={manager}
              pathname={location.pathname}
              paginationObj={paginationObj}
              setShowModal={setShowModal}
              setSearch={setSearch}
            />
            {paginationObj?.totalItems !== 0 && (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                page={page}
              />
            )}
          </div>
        </div>
      </div>
      {addEditModal && (
        <AddEditModal
          setAddEditModal={setAddEditModal}
          allAddress={allAddress}
          item={item}
        />
      )}
    </div>
  )
}

export default City
